import { formatDate } from '@angular/common';
import { ReportRow } from '@contracts';

export function mapReportRows(values: any[]): ReportRow[] {
  return values.map((value, index) => ({
    no: index + 1,
    tenant_name: '',
    sys_meter_name: value.name,
    room: value.location_tier_5,
    shop_name: value.shop_name,
    sub_meter_id: value.sub_meter_id,
    port: value.port,
    name: value.name,
    previous_reading: value.previous_reading,
    date_previous_reading: value.previous_reading_date
      ? formatDate(value.previous_reading_date, 'd/M/yyyy HH:mm:ss', 'en-US')
      : '',
    recent_reading: value.recent_reading,
    date_recent_reading: value.recent_reading_date
      ? formatDate(value.recent_reading_date, 'd/M/yyyy HH:mm:ss', 'en-US')
      : '',
    consumption: value.consumption,
    consumption_status: value.consumption_status,
    conv_ip: value.conv_ip,
    meter_id: value.meter_id,
    group: value.group,
    electricity_rate: value.electricity_rate,
    serial_number: value.serial_number ?? null,
    last_previous_reading_date: value.last_previous_reading_date,
    last_previous_reading: value.last_previous_reading,
    last_recent_reading_date: value.last_recent_reading_date,
    last_recent_reading: value.last_recent_reading,
    last_consumption: value.last_consumption,
    sys_unit_name: value.sys_unit_name,
    panel: value.panel_tier_2,
    location: value.location_tier_1,
    building: value.location_tier_2,
    zone: value.zone,
    floor: value.floor,
    loop: value.loop,
    shaft: value.shaft,
    previous_reading_date: value.previous_reading_date,
    recent_reading_date: value.recent_reading_date,
    type: value.type,
  }));
}
